/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React from 'react';
// Template Views
import IntroductionVideo from './templates/lesson/IntroductionVideo';
import Objectives from './templates/lesson/Objectives';
import SceneSetter from './templates/lesson/SceneSetter';
import TerminologyReview from './templates/lesson/TerminologyReview';
import Reading from './templates/lesson/Reading';
import Listening from './templates/lesson/Listening';
import MultipleChoice from './templates/lesson/MultipleChoice';
import ConceptCategorizing from './templates/lesson/ConceptCategorizing';
import ErrorIdentification from './templates/lesson/ErrorIdentification';
import SummaryEvaluation from './templates/lesson/SummaryEvaluation';
import LinguisticEvaluation from './templates/lesson/LinguisticEvaluation';
import RegisterAnalysis from './templates/lesson/RegisterAnalysis';
import LessonSummary from './templates/lesson/LessonSummary';
import ModuleSummary from './templates/lesson/ModuleSummary';
import Enrichment from './templates/lesson/Enrichment';
// Practical Exercise Views
import PETransition from './templates/practicalexercise/PETransition';
import PEMissionSelection from './templates/practicalexercise/PEMissionSelection';
import PEBrief from './templates/practicalexercise/PEBrief';
import PEEnvironment from './templates/practicalexercise/PEEnvironment';
import FPEEnvironmentHome from './templates/practicalexercise/FPEEnvironmentHome';
import FPEEnvironmentPath from './templates/practicalexercise/FPEEnvironmentPath';
import PEReading from './templates/practicalexercise/PEReading';
import PEInteractiveListening from './templates/practicalexercise/PEInteractiveListening';
import PEReferenceReading from './templates/practicalexercise/PEReferenceReading';
import PEReferenceListening from './templates/practicalexercise/PEReferenceListening';
import PEMultipleChoice from './templates/practicalexercise/PEMultipleChoice';
import PEConceptComprehension from './templates/practicalexercise/PEConceptComprehension';
import PEEmentorObject from './templates/practicalexercise/PEEmentorObject';
import PEInformativeEvent from './templates/practicalexercise/PEInformativeEvent';
import PEDecisionEvent from './templates/practicalexercise/PEDecisionEvent';
import PEObservationEvent from './templates/practicalexercise/PEObservationEvent';
import PEDialogInteraction from './templates/practicalexercise/PEDialogInteraction';
import PEFaceToFaceInteraction from './templates/practicalexercise/PEFaceToFaceInteraction';
import PEPhoneCallInteraction from './templates/practicalexercise/PEPhoneCallInteraction';
import PECompletionEvent from './templates/practicalexercise/PECompletionEvent';
import ConstructedResponse from './templates/practicalexercise/ConstructedResponse';
import PEConstructedDraftReport from './templates/practicalexercise/PEConstructedDraftReport';
import PECapstoneHypothesisResponse from './templates/practicalexercise/PECapstoneHypothesisResponse';
import PECapstonePresentationBrief from './templates/practicalexercise/PECapstonePresentationBrief';
import PEArgumentCounterArgument from './templates/practicalexercise/PEArgumentCounterArgument';
import PECapstoneWhitePaper from './templates/practicalexercise/PECapstoneWhitePaper';
import NoteCards from './templates/practicalexercise/NoteCards';
import PECapstoneOpEdPaper from './templates/practicalexercise/PECapstoneOpEdPaper';
import FPECapstone from './templates/practicalexercise/FPECapstone';
import PEDebrief from './templates/practicalexercise/PEDebrief';
// Assessment Views
import AssessmentIntroduction from './templates/assessment/AssessmentIntroduction';
import AssessmentReadingMC from './templates/assessment/AssessmentReadingMC';
import AssessmentListeningMC from './templates/assessment/AssessmentListeningMC';
import AssessmentSummary from './templates/assessment/AssessmentSummary';
// Introduction Views
import IntroCarousel from './templates/introduction/IntroCarousel';
import TutorialVideo from './templates/introduction/TutorialVideo';
import IntroSummary from './templates/introduction/IntroSummary';

const ContentView = (props) => {
  // decontstruct props
  const { obj, label, rtl, ins, course, comments } = props;
  // set text size based on language direction
  const dir = rtl ? 'rtl' : 'ltr';

  // show template based on title
  // For future improvements, this needs to be refactored
  switch (label) {
    // Lesson Templates
    case 'TMP-L-001':
      return (
        <IntroductionVideo
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-002':
      return (
        <Objectives
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-003':
      return (
        <SceneSetter
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-004':
      return (
        <TerminologyReview
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-005':
      return (
        <Reading
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-006':
      return (
        <Listening
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-007':
      return (
        <MultipleChoice
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-008':
      return (
        <ConceptCategorizing
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-009':
      return (
        <ErrorIdentification
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-010':
      return (
        <SummaryEvaluation
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-011':
      return (
        <LinguisticEvaluation
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-012':
      return (
        <RegisterAnalysis
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-013':
      return (
        <LessonSummary
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-014':
      return (
        <ModuleSummary
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-L-015':
      return (
        <Enrichment
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    // Practical Exercise Templates
    case 'TMP-PE-001':
      return (
        <PETransition
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-002':
      return (
        <PEMissionSelection
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-003':
      return (
        <PEBrief
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-004':
      return (
        <PEEnvironment
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-005':
      return (
        <FPEEnvironmentHome
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-006':
      return (
        <FPEEnvironmentPath
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-007':
      return (
        <PEReading
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-008':
      return (
        <PEInteractiveListening
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-009':
      return (
        <PEReferenceReading
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-010':
      return (
        <PEReferenceListening
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-011':
      return (
        <PEMultipleChoice
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-012':
      return (
        <PEConceptComprehension
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-013':
      return (
        <PEEmentorObject
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-014':
      return (
        <PEInformativeEvent
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-015':
      return (
        <PEDecisionEvent
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-016':
      return (
        <PEObservationEvent
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-017':
      return (
        <PEDialogInteraction
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-018':
      return (
        <PEPhoneCallInteraction
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-019':
      return (
        <PEFaceToFaceInteraction
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-020':
      return (
        <PECompletionEvent
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-021':
      return (
        <ConstructedResponse
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-022':
      return (
        <PEConstructedDraftReport
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-023':
      return (
        <PECapstoneHypothesisResponse
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-024':
      return (
        <PECapstonePresentationBrief
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-025':
      return (
        <PEArgumentCounterArgument
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-026':
      return (
        <PECapstoneWhitePaper
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-027':
      return (
        <NoteCards
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-028':
      return (
        <PECapstoneOpEdPaper
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-029':
      return (
        <FPECapstone
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-PE-030':
      return (
        <PEDebrief
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    // Assessment Templates
    case 'TMP-A-001':
      return (
        <AssessmentIntroduction
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-A-002':
      return (
        <AssessmentReadingMC
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-A-003':
      return (
        <AssessmentListeningMC
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-A-004':
      return (
        <AssessmentSummary
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    // Introduction Templates
    case 'TMP-I-001':
      return (
        <IntroCarousel
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-I-002':
      return (
        <TutorialVideo
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    case 'TMP-I-003':
      return (
        <IntroSummary
          data={obj}
          dir={dir}
          ins={ins}
          course={course}
          comments={comments}
        />
      );
    default:
      return <pre>{JSON.stringify(obj, null, 2)}</pre>;
  }
};

export default ContentView;
